<template>
  <div class="content">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Payments',
};
</script>

<style lang="scss" scoped>
.content {
  margin: 0 auto;
}
</style>
